import { render, staticRenderFns } from "./NewsHubForm.vue?vue&type=template&id=58236d26&scoped=true&"
import script from "./NewsHubForm.vue?vue&type=script&lang=js&"
export * from "./NewsHubForm.vue?vue&type=script&lang=js&"
import style1 from "./NewsHubForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58236d26",
  null
  
)

export default component.exports